var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 20,
    viewBox: "0 0 33 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8611 9.89187C12.8611 6.78328 14.3369 4.0261 16.6051 2.24205C14.9381 0.944549 12.8338 0.160645 10.5382 0.160645C5.09992 0.160645 0.700073 4.51267 0.700073 9.89187C0.700073 15.2711 5.09992 19.6231 10.5382 19.6231C12.8338 19.6231 14.9381 18.8392 16.6051 17.5417C14.3369 15.7847 12.8611 13.0005 12.8611 9.89187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5374 9.89187C32.5374 15.2711 28.1375 19.6231 22.6992 19.6231C20.4036 19.6231 18.2993 18.8392 16.6323 17.5417C18.9279 15.7576 20.3763 13.0005 20.3763 9.89187C20.3763 6.78328 18.9006 4.0261 16.6323 2.24205C18.2993 0.944549 20.4036 0.160645 22.6992 0.160645C28.1375 0.160645 32.5374 4.5397 32.5374 9.89187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.9,
    height: 19.4174,
    fill: "white",
    transform: "translate(0.700073 0.160645)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/masterCard.6f0ffa79e2a421d0bf29a871acb5c129.svg";
export { ForwardRef as ReactComponent };